export default function googleTypesToIconType(googleTypes: string[]): string {
  if (googleTypes.includes("airport")) return "airport";
  else if (googleTypes.includes("lodging")) return "hotel";
  else if (googleTypes.includes("university") || googleTypes.includes("school")) return "school";
  else if (googleTypes.includes("health")) return "health";
  else if (googleTypes.includes("food")) return "food";
  else if (googleTypes.includes("store")) return "store";
  else if (googleTypes.includes("train_station")) return "train";
  else if (googleTypes.includes("street_address")) return "house";
  else if (googleTypes.includes("natural_feature")) return "nature";
  else if (googleTypes.includes("tourist_attraction") || googleTypes.includes("point_of_interest"))
    return "attraction";
  else if (googleTypes.includes("route")) return "road";
  else if (googleTypes.includes("locality") || googleTypes.includes("political")) return "locality";
  else return "generic";
}
